import React from "react";

const SoundWave = () => {
  return (
    <div className="flex items-center justify-center gap-1 h-full w-full">
      {Array.from({ length: 5 }, (_, i) => (
        <div
          key={i}
          className="w-1 bg-primary-300 rounded-full animate-sound-wave"
          style={{
            height: "100%",
            animationDelay: `${i * 0.1}s`,
          }}
        />
      ))}
      <style>
        {`
          @keyframes sound-wave {
            0%, 100% { height: 20%; opacity: 0.7; }
            50% { height: 60%; opacity: 0.9; }
          }
          .animate-sound-wave {
            animation: sound-wave 1s ease-in-out infinite;
          }
        `}
      </style>
    </div>
  );
};

export default SoundWave;
